<template>
  <div class="field radio-label" :class="{ 'is-danger': errors && errors.hasError(name) }">
    <label v-if="label" :for="name" class="label" v-text="label"></label>
    <div class="radio"  v-for="(option, index) in options">
      <radio :name="name" :id="name + '' + index" :label="lang(option.name)" :required="required" :value="option.value" :checked="option.value === input" v-model="input"></radio>
    </div>
    <p class="help is-danger" v-text="errors.get(name)"></p>
  </div>
</template>

<script>
import _ from 'lodash';
import Radio from './Radio.vue'

export default {
  name: "RadioField",
  components: {
    Radio
  },
  props: {
    value: null,
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: Object,
      required: false
    },
    options: {
      type: [Array, Object],
      required: true
    },
  },
  data() {
    return {
      loading: true,
      input: 'privato'
    }
  },
  watch: {
    value( value ) {
      this.input = value
    },
    input( value ) {
      this.errors.clear( this.name );
      this.$emit('input', value);
    }
  }
}
</script>

<style scoped>

</style>